module.exports = __webpack_public_path__ + "2868f1349014531ca7cbed01a42420a4.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ic_accessibility.svg
// module id = FRMY
// module chunks = 5